import { DEFAULT_CLIDS, OPPO_WL_CLID } from '@/constants/general'
import { isBestWebGamesHost } from '@/router/white-label/utils'

type ResolveClidOptions = {
    host?: string
    landingClid?: string
    queryClid?: string
}

export function resolveClid({ host, landingClid, queryClid }: ResolveClidOptions): string {
    if (typeof queryClid === 'string' && queryClid) {
        return queryClid
    }

    if (landingClid) {
        return landingClid
    }

    if (host === 'playgama.com') {
        return DEFAULT_CLIDS.direct
    }

    if (host?.endsWith('.playgama.com')) {
        return DEFAULT_CLIDS.directTest
    }

    if (isBestWebGamesHost(host)) {
        return OPPO_WL_CLID
    }

    return DEFAULT_CLIDS.unknown
}
